import { Kanban, mangeInterviews, SUCCESS_REPONSE_CODE, handleOtherResponseCode,
         UNPROCESSABLE_ENTITY_RESPONSE_CODE, CustomToastrAction, REDIRECT, INTERVIEW_TYPES, setTechTestFormData, JOB_STAGES, ApplicationFilter}  from "@/imports-files/pages/clients/candidates/kanban"
import NumberFormat from 'react-number-format';
import { getCandidateName } from "@/actions/components/candidate-email";
import cloneDeep from 'lodash.clonedeep';

  const TIMER_CONSTANT = 10
  export function onCancelClick()
  {
    document.getElementsByClassName("add-candidate-section")[0]?.classList?.add('displaynone')
    document.getElementsByClassName("add-offer-section")[0]?.classList?.add('displaynone')
    document.getElementsByClassName("kanban-job-section")[0]?.classList?.remove('displaynone')
    document.getElementsByClassName("job-application-view-section")[0]?.classList?.remove('displaynone')
  }

  export function showAddCandidate(setShowCandidate)
  {
    setShowCandidate(true)
    document.getElementsByClassName("kanban-job-section")[0].classList.add('displaynone')
    document.getElementsByClassName("add-candidate-section")[0].classList.remove('displaynone')
  }

  export function showAddOffer(setShowOffer, from){
    setShowOffer(true)
    if(from == "application_view")
      document.getElementsByClassName("job-application-view-section")[0]?.classList?.add('displaynone')
    else 
      document.getElementsByClassName("kanban-job-section")[0].classList.add('displaynone')
    document.getElementsByClassName("add-offer-section")[0].classList.remove('displaynone')
  }

  export function showCompareCandidate(){
    document.getElementsByClassName("kanban-job-section")[0].classList.add('displaynone')
    document.getElementsByClassName("compare-candidate-section")[0].classList.remove('displaynone')
  }
  export function hideCompareCandidate(){
    document.getElementsByClassName("kanban-job-section")[0].classList.remove('displaynone')
    document.getElementsByClassName("compare-candidate-section")[0].classList.add('displaynone')
  }

  export function NumberField({field, className, disabled, format, placeholder}) {
    return <NumberFormat {...field} placeholder={placeholder} format={format} name={field.name} className={className} disabled={disabled}/>;
  }

  export async function submitOffer(args) 
  {
    let result                  =     {}
    args.values.from            =     args.from
    const customToastrAction    =     new CustomToastrAction();
    args.setShowLoader(true);
    if(args.offer_id)  
      result = await new Kanban().updateOffer(args.values, args.offer_id);
    else 
      result = await new Kanban().createOffer(args.values);
    const status_code = result.status || result.response.status;
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        if(args.from == "kanban") { args.setJobData(result.data.kanban_data) }
        if(args.from == "application_view") { args.setInitialData(result.data.application_data) }
        if(args.syncNowBtnClick){
          if(args.from == "application_view"){
            syncNowHiredData(args.router.query.job_id, {job_application_id: result.data.application_data.application.id, from: args.from});
          }
          else{
            syncNowHiredData(args.router.query.job_id, {job_application_id: result.data.job_application_id, from: args.from, setHiredSyncNowBtn: args.setHiredSyncNowBtn, setHiredSyncModal: args.setHiredSyncModal, setJobData: args.setJobData});
          }
        }
        onCancelClick();
        customToastrAction.setNormalToastr(result.data.success, 'success');
        break;
      case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        let message = "";
        if(result.response.data.error.offer?.offer_approver_emails){
          message +=  `${result.response.data.error.offer.offer_approver_emails}`
        }
        if(result.response.data.error.offer?.new_user_emails){
          message +=  `${result.response.data.error.offer.new_user_emails}`
        }
        if(message.length > 0) { new CustomToastrAction().setNormalToastr(message, 'error');}
        else {
          customToastrAction.setNormalToastr('Offer has already been created.', 'error');
        }
        const offer_error = result.response.data.error
        delete offer_error.offer["offer_approver_emails"]
        return result.response.data
        break;
      default: 
        handleOtherResponseCode(status_code,args.router);
    }
    args.setShowLoader(false);
  }


export async function fetchMoreData(job_slug, job_stage_id, page, status, per_page, router, filterData){
  const params = Object.assign({}, filterData)
  params.page = page
  params.per_page = per_page
  params.job_stage_id = job_stage_id
  params.status = status
  const result                =     await new Kanban().filterdKanbanData(job_slug, params);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      return result.data.kanban_data.lanes[0].cards || []
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default: 
      handleOtherResponseCode(status_code, router);
  }

  
}

export function automationClick(job_id, job_stage_id, setCurrentStage, setBtnPopup, router, isOpen){
  mangeInterviews(job_id, {id: job_stage_id}, setCurrentStage, setBtnPopup, router, isOpen)
}

export async function getFilterdData(job_slug, filterData, setJobData, status, setSelectedCards, setActionBar){
  filterData.status = status
  const result = await new Kanban().filterdKanbanData(job_slug, filterData);
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    await setJobData(result.data.kanban_data)
    clearRadioButtonSelection(setSelectedCards, status, setActionBar)
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      break;
    default: 
      handleOtherResponseCode(status_code, router);
  }
}

export async function closeJob(job_id, router){
  const result = await new Kanban().closeJob(job_id);
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      window.location.reload();
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      break;
    default: 
      handleOtherResponseCode(status_code, router);
  }
}

export async function getCandidatesFromDatabase(args)
{
  const result                =   await new Kanban().importCandidates(args.job_id);
  const status_code           =   result.status || result.response.status;
  const customToastrAction    =   new CustomToastrAction();
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      args.setJobData(result.data.kanban_data)
      if(result.data.automations_hsh) setAutomationHash(args, result.data.automations_hsh)
      manageAutomationTimer(args);
      args.setLoading(false)
      customToastrAction.setNormalToastr(result.data.success, 'success');
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      args.setLoading(false)
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      // toastr.error(result.response.data.error)
      break;
    default: 
      args.setLoading(false)
      handleOtherResponseCode(status_code, args.router);
  }
}

export function addParamsToUrl(queryParams, router)
{
    router.push({
                    pathname :  router.asPath.split('?')[0],
                    query    :  queryParams
                })
}

export async function handleCardCheckbox(event, selectedCards, setSelectedCards, actions, setActions, setActionBar, totalCardsCount, jobData, activeTab){
  let stage_id        = event.target.getAttribute('data-stage_id')
  let application_id  = event.target.getAttribute('data-application_id')
  if(event.target.checked){
    if(stage_id == selectedCards.stage_id)
    {
      if(selectedCards.job_application_ids.indexOf('all') != -1 )
      {
        selectedCards.rejected_ids.splice(selectedCards.rejected_ids.indexOf(application_id), 1)
      }
      else
      {
        selectedCards.job_application_ids.push(application_id)
      }
      await setSelectedCards(selectedCards)
      await setActions(await modifyActions(jobData, selectedCards, actions));
      await setActionBar(true)
    }
    else {
      let page_all_checkbox   = document.querySelectorAll('.react-trello-board input[type="checkbox"]');
      for( var element of page_all_checkbox)
      {
        element.checked = false;
      }
      event.target.checked = true;
      selectedCards.stage_id = stage_id
      selectedCards.job_application_ids = [application_id]
      selectedCards.rejected_ids = []
      await setSelectedCards(selectedCards)
      await setActions( await modifyActions(jobData, selectedCards, actions));
      await setActionBar(true)
   }
  }
  else{
    if(stage_id == selectedCards.stage_id){
      if(selectedCards.job_application_ids.indexOf(application_id) != -1) selectedCards.job_application_ids.splice(selectedCards.job_application_ids.indexOf(application_id), 1)

      var selected_lane       = event.target.closest('.react-trello-lane');
      let page_parent_checkbox   = selected_lane.querySelectorAll('input[type="checkbox"]')[0];
      page_parent_checkbox.checked = false;

      if(selectedCards.job_application_ids.indexOf('all') != -1 )
      {
        selectedCards.rejected_ids.push(application_id)
      }
      await setSelectedCards(selectedCards)
      if(selectedCards.rejected_ids.length == totalCardsCount){
        selectedCards.job_application_ids = []
        selectedCards.rejected_ids = []
        selectedCards.stage_id = ""
        await setSelectedCards(selectedCards)
        await setActionBar(false)
      }
      else if(selectedCards.job_application_ids.length > 0){
        await setActions(await modifyActions(jobData, selectedCards, actions));
        await setActionBar(true)
      }
      else{
        await setActionBar(false)
      }
    }
  }
}

export async function handleLaneCheckbox(event, selectedCards, setSelectedCards, actions, setActions, setActionBar, jobData, activeTab){
  let stage_id = event.target.getAttribute('data-stage_id')
  if(event.target.checked){
    if(stage_id == selectedCards.stage_id){
      selectedCards.job_application_ids = ["all"]
      selectedCards.rejected_ids = []
      selectedCards.status = activeTab
      await setSelectedCards(selectedCards)

      var selected_lane       = event.target.closest('.react-trello-lane');
      var page_all_checkbox   = selected_lane.querySelectorAll('input[type="checkbox"]:not(:disabled)');
      for( var element of page_all_checkbox)
      {
        element.checked = true;
      }
      await setActions(await modifyActions(jobData, selectedCards, actions));
      await setActionBar(true)
    }
    else{
      let page_all_checkbox   = document.querySelectorAll('.react-trello-board input[type="checkbox"]');
      for( var element of page_all_checkbox)
      {
        element.checked = false;
      }
      event.target.checked = true;
      selectedCards.job_application_ids = ["all"]
      selectedCards.rejected_ids = []
      selectedCards.stage_id = stage_id
      selectedCards.status = activeTab
      let selected_lane       = event.target.closest('.react-trello-lane');
      let page_stage_checkbox   = selected_lane.querySelectorAll('input[type="checkbox"]:not(:disabled)');
      for( var element of page_stage_checkbox)
      {
        element.checked = true;
      }
      await setActions(await modifyActions(jobData, selectedCards, actions));
      await setActions(actions);
      await setActionBar(true)
    }
  }
  else {
    let page_all_checkbox   = document.querySelectorAll('.react-trello-board input[type="checkbox"]');
    for( var element of page_all_checkbox)
    {
      element.checked = false;
    }
    selectedCards.job_application_ids = []
    selectedCards.rejected_ids = []
    selectedCards.stage_id = ""
    selectedCards.status = activeTab
    await setSelectedCards(selectedCards)
    await setActionBar(false)
  }
}

async function modifyActions(jobData, selectedCards, actions){
  let lane = jobData.lanes.filter((x) => x.id.toString() == selectedCards.stage_id)[0]
  if([JOB_STAGES.SCREENING, JOB_STAGES.INTERVIEW].includes(lane.stage) && !lane.automation){
    let visibleAction = await isNotSent({selectedCards: selectedCards, job_data: jobData})
    if(visibleAction) {
      let actionsCopy = Object.assign({}, actions)
      actionsCopy.other = actions.other.filter((x) => x.name != 'setup_new_interview')
      return actionsCopy
    }
    else{
      let actionsCopy = Object.assign({}, actions)
      actionsCopy.actions = actions.actions.filter((x) => x.name != 'setup_interview')
      return actionsCopy
    }
  }
  else{
    return actions
  }
}

export function showUnsuccessful(job_data, stage_id, status){
  let stage = job_data.lanes.filter((x) => x.id == stage_id.toString())[0]
  let stageCategory = stage?.stage_category;
  if(status == "unsuccessful") return false;
  if(stageCategory == "Interview")
  {
    return true
  }
  return false
}

export async function performAction(args){
  
  let unsuccessfulPopup = showUnsuccessful(args.job_data, args.selectedCards.stage_id, args.activeTab)
  if(args.moving_status == 'active'){
    // args.setIsActiveEmail(true)
    // args.setCandidateEmailModal(true);
    args.setIsActiveConfirmation(true)
  }
  else if (isPendingInterview(args)){
    args.setUnsuccessConfirmation(true)
  }
  else if(unsuccessfulPopup){
    args.setUnsuccessfulModal(true)
  }
  else{
    markActiveUnsuccessful(args)
  }
}

export async function markActiveUnsuccessful(args){ 
  args.selectedCards.status = args.activeTab
  args.selectedCards.moving_status = args.moving_status
  if(args.from == 'kanban') args.filterData.status = args.activeTab
  args.filterData.kanban = args.selectedCards
  args.filterData.from = args.from
  args.setLoading(true);
  const  result               =     await new Kanban().markActiveUnsuccessful(args.job_id, args.filterData);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      args.setLoading(false);
      if(args.from == "kanban") {
        if(args.moving_status == 'unsuccessful'){
          if(args.setCandidateCount) await args.setCandidateCount(getCandidateCount(args.job_data || args.jobData, args.selectedCards))
          if(args.setFirstCandidateName) await args.setFirstCandidateName(getCandidateName(args.selectedCards))
        }
        else{
          clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)
        }
        args.setJobData(result.data.kanban_data)
      }
      else {
        args.setInitialData(result.data.application_data)
      }
      if(args.selectedCards?.reason_id && args.setUnsuccessfulModal) { args.setUnsuccessfulModal(false)}
      if(result.data.automations_hsh)
      {
        setAutomationHash(args, result.data.automations_hsh)
        manageAutomationTimer(args)
      }
      if(result.data.warning && result.data.warning.length > 0) 
      {
        customToastrAction.setNormalToastr(result.data.warning, 'error');
      }
      else
      { 
        customToastrAction.setNormalToastr(result.data.success, 'success');
 
      }
      if(args.setIsActiveConfirmation) args.setIsActiveConfirmation(false)
      if(args.setUnsuccessConfirmation) args.setUnsuccessConfirmation(false)
      if(args.setUnsuccessfulEmailConfirmation && (args.moving_status == 'unsuccessful')) args.setUnsuccessfulEmailConfirmation({ state: true, unsuccessful_candidates_token: result.data.unsuccessful_candidates_token })
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      args.setLoading(false);
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      // toastr.error(result.response.data.error)
      break;
    default: 
      args.setLoading(false);
      handleOtherResponseCode(status_code, args.router);
  }
}


export async function addToAnotherJob(job_id, selectedJobId, params, router, setCandidateAddToJobModal, setAutomationActions, setAutomationBar, restart, setTimerStatus, from, setSelectedCards, activeTab, setActionBar){
  params.job_id               =     selectedJobId
  const  result               =     await new Kanban().addToJob(job_id, params);
  const  status_code          =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      if(from == 'kanban') clearRadioButtonSelection(setSelectedCards, activeTab, setActionBar)
      // setAutomationHash({setAutomationActions: setAutomationActions, showAutomationPopup: false, setAutomationBar: setAutomationBar}, result.data.automations_hsh)
      setCandidateAddToJobModal(false)
      // manageAutomationTimer({restart: restart, setTimerStatus: setTimerStatus  })
      customToastrAction.setNormalToastr(result.data.success, 'success');
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      setCandidateAddToJobModal(false)
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      // toastr.error(result.response.data.error)
      break;
    default: 
      handleOtherResponseCode(status_code, router);
  }
}

export async function sendCustomTechTest(args){
  args.params.days_to_expire  =     args.values.days_to_expire
  args.params.test_id         =     args.values.test_id
  args.params.test_type       =     args.values.test_type
  args.params.member_emails   =     args.values.member_emails
  args.params.assessment      =     args.values.assessment

  if(args.from == 'application_view'){
    args.params.candidate_index = args.router?.query?.candidate_index
    args.params.base_stage_id = args.router?.query?.job_stage_id
    let sortByFilterData = ApplicationFilter(args.job_id);
    if(sortByFilterData){
      args.application_filter_data = sortByFilterData;
    }
  }

  const  result               =     await new Kanban().sendTechTest(args.job_id, args.params, args.from, args.application_filter_data);
  const  status_code          =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      args.setBtnPopup(false)
      if(args.from == "kanban") 
      {
        clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)
        if(result.data.kanban_data) args.setJobData(result.data.kanban_data)
      }

      if(args.from == "application_view") 
      {
        args.setInitialData(result.data.application_data);
      }

      if(result.data.warning && result.data.warning.length > 0) 
      {
        customToastrAction.setNormalToastr(result.data.warning, 'error');
      }
      else
      {
        customToastrAction.setNormalToastr(result.data.success, 'success');
      }
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      args.setBtnPopup(false)
      customToastrAction.setNormalToastr(result.response.data.error, 'error');
      break;
    default: 
      handleOtherResponseCode(status_code, args.router);
  }

  args.setFlagForRerender(Math.random() * 10000);
}

export function showErrors(errors){
  let message = ""
  Object.keys(errors).map(x => {
    switch(x){
      case "calendars_connected": 
        message = message += `${errors.calendars_connected} </br>`
        break;
      case "video_platforms_connected":
        message = message += `${errors.video_platforms_connected} </br>`
        break;
      case "available_slots":
        message = message += `${errors.available_slots} </br>`
        break;
    }
  });
  return message;
}

export function automationPopup(jobData, stage_id){
  let currentLane =  jobData.lanes.filter(x => {
    return stage_id.toString() == x.id.toString()
  })[0]
  return !currentLane.automation
}

export function setAutomationHash(args, automationHash)
{
  automationHash.rejected_ids = automationHash?.rejected_ids || []
  args.setAutomationActions(automationHash)
  if(args.showAutomationPopup && (args.from == 'application_view'))
  {
    args.setSendAutomation(true)
    automationClick(args.job_id, automationHash.stage_id, args.setCurrentStage, args.setBtnPopup, args.router, false)
  }
  else if(!args.showAutomationPopup){
    args.setAutomationBar(true)
  }
}

export function manageAutomationTimer(args){
  let time = new Date();
  time.setSeconds(time.getSeconds()+TIMER_CONSTANT)
  args.restart(time)
  args.setTimerStatus(true)
}

export async function moveToNextStage(args){
  let selectedCards           =   args.selectedCards 
  selectedCards.move_to       =   args.to_stage
  args.filterData.kanban      =   selectedCards
  args.filterData.from        =   args.from
  const charlieHr             =   process.env.NEXT_PUBLIC_CHARLIE_HR
  if (args.from == "application_view"){
    args.filterData.kanban.candidate_index =   args.candidateIndex
    args.filterData.kanban.base_stage_id = args.filterData.kanban.stage_id
    args.filterData.kanban.stage_id = args.candidateCurrentStageId
    let sortByFilterData = ApplicationFilter(args.job_id);
    if(sortByFilterData){
      args.filterData.application_filter_data = sortByFilterData;
    }
  }
  const customToastrAction    =   new CustomToastrAction();
  const  result               =   await new Kanban().moveCandidates(args.job_id, args.filterData);
  const  status_code          =   result.status || result.response.status;

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      if(args.from == 'kanban') 
      {
        clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)
        args.setJobData(result.data.kanban_data)
        // if (result.data.kanban_data.candidate_hired){
        //     args.setHiredModal(true)
        //    }

        if(charlieHr == 'true' && args.targetLaneName == 'Hired' && args.hired_sync_data.hired_synced_data_empty) args.setHiredSyncModal({state: true, action: { hiredSyncData: args.hired_sync_data, data: result.data}})
      }
      if(args.from == 'application_view') 
      {
        args.setInitialData(result.data.application_data);
        let moved_success_message = 'Candidate moved successfully to ' + result.data.application_data.application.current_stage_name.toLowerCase() + ' stage';
        customToastrAction.setNormalToastr(moved_success_message, 'success');
      }
      if(result.data.automations_hsh)
      {
        setAutomationHash(args, result.data.automations_hsh)
        manageAutomationTimer(args)
      }
      else if(result.data.offer_hsh && result.data.application_current_stage != 'Hired') {
        if(!args.isContract){
          args.setOfferHash(result.data.offer_hsh)
          showAddOffer(args.setShowOffer, args.from);
        }
      }
      if(result.data.warning && result.data.warning.length > 0) 
      {
        customToastrAction.setNormalToastr(result.data.warning, 'error');
      }
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        if(args.from == 'kanban'){clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)}
        customToastrAction.setNormalToastr(result.response.data.error, 'error');
        // toastr.error(result.response.data.error)
        break;
      default: 
        handleOtherResponseCode(status_code, args.router);
  }
}

function setJobStageTestData(body, params, deleteQuestionList){
  // if(values.hasOwnProperty("job_test_detail_attributes") && values.job_test_detail_attributes)
  // {
  //   if(values.job_test_detail_attributes.assessment.file == '') delete values.job_test_detail_attributes.assessment.file
  //   filterData.job_stage = { }
  //   filterData.job_stage.automation = values.automation
  //   filterData.assessment = values.job_test_detail_attributes.assessment
  //   delete values.job_test_detail_attributes.assessment
  //   filterData.job_stage.job_test_detail_attributes = values.job_test_detail_attributes
  //   filterData.save_and_continue = values.save_and_continue
  // }
  // else{
  //   filterData.job_stage = values
  // }
  body.job_stage  = {automation: params.automation, interview_type_id: params.interview_type_id, job_meeting_details_attributes: params.job_meeting_details_attributes}
  if(params.interview_type == INTERVIEW_TYPES.TECHTEST){
    let techTestBody  =   setTechTestFormData(params)
    body.job_stage.job_test_detail_attributes = techTestBody.job_stage.job_test_detail_attributes
    if(techTestBody.assessment) body.assessment = techTestBody.assessment
    if(techTestBody.save_and_continue) body.save_and_continue = techTestBody.save_and_continue
  }

  if(params.interview_type == INTERVIEW_TYPES.VIDEOQA){
    let questions_attributes = Object.assign( [], params.questions_attributes, deleteQuestionList)
    let video_question_details_attributes = {
      language: params.language,
      video_link: params.video_link,
      practise_screen: params.practise_screen,
      expires: params.expires,
      member_emails: params.videoqa.member_emails,
      questions_attributes: Object.assign( [], params.questions_attributes, deleteQuestionList)
    }
    body.job_stage.video_question_details_attributes = video_question_details_attributes
  }
  return body
}

export async function runAutomations(args){
  let selectedCards            =  args.selectedCards 
  if(args.fromPopup) 
  { 
    args.filterData = setJobStageTestData(args.filterData, JSON.parse(JSON.stringify(args.values)), args.deleteQuestionList)
    if(args.setDisabled) args.setDisabled(true)
  }

  selectedCards.perform_action =  true
  args.filterData.kanban       =  selectedCards
  args.filterData.from         =  args.from

  if (args.from == "application_view"){
    args.filterData.kanban.candidate_index =   args.candidateIndex
    args.filterData.kanban.base_stage_id = args.base_stage_id
    if(args.candidateCurrentStageId) {
      args.filterData.kanban.stage_id = args.candidateCurrentStageId
    }
  }

  if(!args.fromPopup && args.values){
    args.filterData.kanban.email = args.values
    args.filterData.kanban.email.cc = args.selectedValues ? getEmails(args.selectedValues) : []
    args.filterData.kanban.key = args.reviewKey
  } 

  if(args.reviewKey) args.filterData.kanban.key =  args.reviewKey

  // if(args.values && (typeof args.values.job_stage_attributes != 'undefined'))
  // {
  //   args.filterData.kanban.job_stage['job_stage_id'] = args.selectedCards.stage_id;
  //   args.filterData.kanban.job_stage.job_stage_attributes['id'] = args.selectedCards.stage_id;
  //   args.filterData.kanban.job_stage.job_stage_attributes['job_id'] = args.job_id;
  // }
                            
  const result                =     await new Kanban().runAutomations(args.job_id, args.filterData);
  const  status_code          =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      
      if(args.reviewKey && args.setUnsuccessfulEmailModal) args.setUnsuccessfulEmailModal(false)
      
      if(args.fromPopup && !args.fromPopup ) 
      {
        clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar) 
      }

      if(args.fromPopup)
      {
        args.setSendAutomation(false)
        args.setBtnPopup(false)
      }
      
      if(args.from == "kanban")
      { 
        args.setJobData(result.data.kanban_data) 
      }
      else
      {
        args.setInitialData(result.data.application_data) 
      }

      let warning = ''
      
      if(result.data.warning && result.data.warning.length > 0) 
      {
        warning += result.data.warning
      }
      
      if(result.data.contact_warning && result.data.contact_warning.length > 0) 
      {
        warning += result.data.contact_warning
      }
      
      if(warning.length > 0) customToastrAction.setNormalToastr(warning, 'error');
      else if(result.data.success && args.filterData?.kanban?.email?.email_body) customToastrAction.setNormalToastr(result.data.success, 'success');
      else if(result.data.success) customToastrAction.setNormalToastr(result.data.success, 'success');

      // args.setFlagForRerender(Math.random()*10000);
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      if(args.fromPopup && !args.fromPopup) clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar)
      if(args.fromPopup){
        if(result.response.data.error.job_stage?.job_test_detail_attributes?.test_attributes)
        {
          const errors = {
            job_test_detail_attributes: {
              assessment: result.response.data.error.job_stage.job_test_detail_attributes.test_attributes
            }
          }
          return errors
        }  
        else{
          args.setSendAutomation(false)
          args.setBtnPopup(false)
        }
        if(args.setDisabled) args.setDisabled(false)
      }
      let error_message = showErrors(result.response.data.error)
      error_message.length > 0 ? customToastrAction.setNormalToastr(error_message, 'error')
                               : customToastrAction.setNormalToastr(result.response.data.error, 'error');                        
      break;
    default: 
      handleOtherResponseCode(status_code, args.router);
  }
}

export async function clearRadioButtonSelection(setSelectedCards, activeTab, setActionBar){
  setSelectedCards({
    stage_id: '',
    job_application_ids: [],
    rejected_ids: [],
    status: activeTab,
  })
  setActionBar(false)
}

export async function getOfferHash(args)
{
  const params                =     args.job_application_id ? {job_application_id: args.job_application_id} : {id: args.id}
  const  result               =     await new Kanban().getOfferDetail(params);
  const  status_code          =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      if(result.data.offer_hsh) {
        args.setOfferHash(result.data.offer_hsh)
        showAddOffer(args.setShowOffer, args.from);
      }
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
        customToastrAction.setNormalToastr(result.response.data.error, 'error');
        // toastr.error(result.response.data.error)
        break;
      default: 
        handleOtherResponseCode(status_code, args.router);
  }
}

export function redirectContractPage(job_id, job_application_id, isTemplate) {
  let send_contract_url = REDIRECT.client.jobs.send_contract.replace('$job_id', job_id).replace('$job_application_id', job_application_id)
  if(isTemplate){
    send_contract_url = REDIRECT.client.jobs.send_template_contract.replace('$job_id', job_id).replace('$job_application_id', job_application_id)
  }
  let protocol       =  window.location.protocol;
  let host           =  window.location.host;
  let url            =  protocol + '//' + host + send_contract_url;
  window.open(url, "_self")
}

export function redirectToEsignPage(job_id, job_application_id, isTemplate) {
  const esignUrl = isTemplate
    ? REDIRECT.client.jobs.send_template_esign
    : REDIRECT.client.jobs.send_esign;

  const formattedUrl = esignUrl
    .replace("$job_id", job_id)
    .replace("$job_application_id", job_application_id);

  const url = `${window.location.protocol}//${window.location.host}${formattedUrl}`;
  window.open(url, "_self");
}

export async function getReasonsList(name, router){
  const body                  =     {search_text: name }
  const result                =     await new Kanban().unsuccessfulReasons(body);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    return response.unsuccessful_reasons || []
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    return [];
  default: 
    handleOtherResponseCode(status_code, router);
  }
}

export async function getScorecards(job_application_id, router) {
  const result                =     await new Kanban().scoreCards(job_application_id);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    return result.data
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    return null
  default: 
    handleOtherResponseCode(status_code, router);
  }
}

export async function getSingleScorecard(job_application_id, router, scorecard_id) {
  const result                =     await new Kanban().singleScoreCards(job_application_id, scorecard_id);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();
  switch (status_code)
  {
  case SUCCESS_REPONSE_CODE:
    return result.data
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    return [];
  default:
    handleOtherResponseCode(status_code, router);
  }
}

export async function compareCandidateScorecards(job_id, params, router) {
  const body = {kanban: params}
  const result                =     await new Kanban().compareScoreCards(job_id, body);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    if(result.data.warning && result.data.warning.length > 0) customToastrAction.setNormalToastr(result.data.warning, 'warning');
    return result.data
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    return [];
  default: 
    handleOtherResponseCode(status_code, router);
  }
}

export async function reviewAutomationEmail(job_id, router, params)
{
  const result                =     await new Kanban().reviewAutomationEmail(job_id, params);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    return result.data
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    return [];
  default: 
    handleOtherResponseCode(status_code, router);
  }
}

export function getEmails(values)
{
    var emails = []; 
    for(var element of values)
    {
    emails.push(element.email)
    }

    return emails;
}

export async function send_unsuccessful_email(args)
{
  const params                =     { kanban: args.selectedCards}
  params.kanban.email         =     args.values
  params.kanban.email.cc      =     getEmails(args.selectedValues);
  params.kanban.key           =    'active_or_unsuccessful'
  params.kanban.unsuccessful_candidates_token = args.unsuccessful_candidates_token
  const result                =     await new Kanban().sendUnsuccessfulEmail(args.job_id, params);
  const status_code           =     result.status || result.response.status;
  const customToastrAction    =     new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      await args.setUnsuccessfulEmailModal(false)
      if(args.from == 'kanban'){ await clearRadioButtonSelection(args.setSelectedCards, args.activeTab, args.setActionBar) }
      customToastrAction.setNormalToastr(result.data.success, 'success');
    return result.data
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    return [];
  default: 
    handleOtherResponseCode(status_code, args.router);
  }
}

export async function sendOfferToCandidate(params, setBtnPopup, setInitialData, setShowLoader){
  var body = params
  setShowLoader(true);
  const result    =   await new Kanban().sendOffer(body);
  const customToastrAction    =     new CustomToastrAction();
  if(setBtnPopup) setBtnPopup({state: false})
  if(result.request.status == 200){
    setInitialData(result.data.application_data)
    customToastrAction.setNormalToastr(result.data.success, 'success')
  }else{
    customToastrAction.setNormalToastr(result.response.data.error, 'error')
  }
  setShowLoader(false);
  return result;
}

function isPendingInterview(args){
  let pending_interview = false
  if(args.selectedCards.job_application_ids.indexOf('all') != -1)
  { 
    args.job_data.lanes.filter((x) => x.id.toString() == args.selectedCards.stage_id.toString())[0].cards.map((y) => {
      if(!args.selectedCards.rejected_ids.includes(y.id.toString())){
        pending_interview = pending_interview || y.pending_interview
      }
      return y
    })
  }
  else{
    args.job_data.lanes.filter((x) => x.id.toString() == args.selectedCards.stage_id.toString())[0].cards.map((y) => {
      if(args.selectedCards.job_application_ids.includes(y.id.toString())){
        pending_interview = pending_interview || y.pending_interview
      }
      return y
    })
  }
  return pending_interview
}

export function isScheduledInterview(args){
  let scheduled_interview = false
  if(args.selectedCards.job_application_ids.indexOf('all') != -1)
  {
    args.job_data.lanes.filter((x) => x.id.toString() == args.selectedCards.stage_id.toString())[0].cards.map((y) => {
      if(!args.selectedCards.rejected_ids.includes(y.id.toString())){
        scheduled_interview = scheduled_interview || y.scheduled_interview
      }
      return y
    })
  }
  else{
    args.job_data.lanes.filter((x) => x.id.toString() == args.selectedCards.stage_id.toString())[0].cards.map((y) => {
      if(args.selectedCards.job_application_ids.includes(y.id.toString())){
        scheduled_interview = scheduled_interview || y.scheduled_interview
      }
      return y
    })
  }
  return scheduled_interview
}

function getCandidateCount(job_data, selectedCards) {
    let count = 0
    let stage = job_data.lanes.filter((x) => x.id == selectedCards.stage_id.toString())[0]
    if (selectedCards.job_application_ids.indexOf('all') != -1) {
      count = stage.count - selectedCards.rejected_ids.length
    }
    else {
      count = selectedCards.job_application_ids.length
    }
    return count;
  }

  export async function isNotSent(args){
    let not_sent_interviews = false
    if(args.selectedCards.status == "unsuccessful") return not_sent_interviews
    if(args.selectedCards.job_application_ids.indexOf('all') != -1)
    {
      not_sent_interviews = await checkNotSent({job_stage_id: args.selectedCards.stage_id, job_application_ids: args.selectedCards.job_application_ids, rejected_ids: args.selectedCards.rejected_ids})
    }
    else{
      args.job_data.lanes.filter((x) => x.id.toString() == args.selectedCards.stage_id.toString())[0].cards.map((y) => {
        if(args.selectedCards.job_application_ids.includes(y.id.toString())){
          not_sent_interviews = not_sent_interviews || (y.primary_status == 'Not Sent')
        }
        return y
      })
    }
    return not_sent_interviews
  }

  async function checkNotSent(args) {
    const result = await new Kanban().checkNotSent({job_application_meeting: args});
    const status_code           =     result.status || result.response.status;
    const customToastrAction    =     new CustomToastrAction();

    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      const response = result.data;
      return response.not_sent_exists;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      return false;
      break;
    default:
      return false;
      // handleOtherResponseCode(status_code, router);
    }
  }

  export async function sendQuestions(args, setBtnPopup, from, setLoading, setData, kanban_args) {
    setLoading(true)
    args.from = from
    const result = await new Kanban().sendQuestions(args.job_id, args);
    const status_code           =     result.status || result.response.status;
    const customToastrAction    =     new CustomToastrAction();
    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
      setBtnPopup(false)
      customToastrAction.setNormalToastr( result.data.success, 'success');
      setLoading(false)
      if(from == 'application_view'){
        setData(result.data.application_data)
      }else{
        setData(result.data.kanban_data)
      }
      if(from == 'kanban'){ await clearRadioButtonSelection(kanban_args.setSelectedCards, kanban_args.activeTab, kanban_args.setActionBar) }
      break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      setBtnPopup(false)
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      setLoading(false)
      if(from == 'kanban'){ await clearRadioButtonSelection(kanban_args.setSelectedCards, kanban_args.activeTab, kanban_args.setActionBar) }
      break;
    default:
      setLoading(false)
      handleOtherResponseCode(status_code, router);
    }
  }

// TODO put all the function in the class so that we should not write multiple imports 
// on the import files and the page 
export class KanbanActions
{
  setBackArrowTitle(type)
  {
    switch(type)
    {
      case "reports": return 'Back to reports';
      default       : return 'Back to all jobs';
    }
  }

  setBackPageLink(type)
  {
    switch(type)
    {
      case "reports": return { pathname: REDIRECT.client.reports.in_process };
      default       : return { pathname: REDIRECT.client.jobs.index, query: {job_type: 'Active'}};
    }
  }
}

export async function syncNowHiredData(job_id, args){
  const result = await new Kanban().syncNowHiredDataService(job_id, args);
  const customToastrAction    =     new CustomToastrAction();
  const  status_code          =   result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      if(args.from == "kanban"){
        args.setHiredSyncNowBtn({state: false, action: {}})
        args.setJobData(result.data.kanban_data);
      }else{
        args.setInitialData(result.data.application_data);
      }
      customToastrAction.setNormalToastr( result.data.success, 'success');
      if (result.data.kanban_data.candidate_hired){
          setTimeout(() => {
            args.setHiredModal(true)
                       }, 2000)
        }
    break;
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
      if(args.from == "kanban") args.setHiredSyncModal({state: false, action: {}})
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    break;
    default:
      handleOtherResponseCode(status_code, args.router);
  }

}
